import {i18n} from '@/plugins/i18next';
import BackendLogger from "@/plugins/backend-logger";

export const translation = {
  namespaced: true,
  state: {
    language: localStorage.getItem(process.env.VUE_APP_LANGUAGE_STORAGE),
    importMap: new Map(),
    namespaces: [],
  }, mutations: {
    storeLanguage(state, lang) {
      state.language = lang;
      localStorage.setItem(process.env.VUE_APP_LANGUAGE_STORAGE, lang ? lang : '');
    },
    updateImportMap(state, map) {
      if(!map){
        return;
      }
      //check and add missing languages
      map.forEach(function(value,key) {
        if(state.importMap.has(key)){
          if(value) {
            //check and add missing namespaces
            let languageMap = state.importMap.get(key);
            if(languageMap){
              value.forEach(function(value2, key2) {
                languageMap.set(key2,value2);
              });
            }
            else {
              BackendLogger.warn("Attempted to add map with key '" + key +"', but languageMap was missing for state.");
            }
          }
          else {
            BackendLogger.warn("Attempted to add map with key '" + key +"', but no value in new map.");
          }
        }
        else {
          state.importMap.set(key,value);
        }
      });
    },
    updateNamespaces(state, payload) {
      state.namespaces = payload;
    },
    loadNamespaces(state) {
      if(!state.language){
        state.language = "en"
      }
      let languageMap = state.importMap.get(state.language);
      if(!languageMap){
        BackendLogger.warn("Attempted to load non existing locale '" + state.language + "' from map.");
        return;
      }
      //check namespaces and loading resources according to them + currently set language
      if(state.namespaces && state.namespaces.length > 0){
        state.namespaces.forEach((ns) => {
          if(!i18n.i18next.hasResourceBundle(state.language, ns)) {
            let importFunc = languageMap.get(ns);
            if (importFunc) {
              importFunc().then((json) => {
                i18n.i18next.addResourceBundle(
                    state.language,
                    ns,
                    json
                )
              }).catch((error) => {
                BackendLogger.error("Failed loading language file for namespace '" + ns + "', because: " + error);
              })
            }
            else {
              BackendLogger.warn("Import Function missing for namespace '" + ns +"'.");
            }
          }
        })
      }
    }
  }
}
